import { gsap, Power4 } from 'gsap'
import { CustomEase} from 'gsap/CustomEase'
import { breakpoint } from './breakpoint-setup'

gsap.registerPlugin(CustomEase)

let timelineConfigSpeed = breakpoint('screen') > breakpoint('sm') ? (breakpoint('screen') > breakpoint('lg') ? 700 : 400) : 250

let timelineConfig = {
  speed : timelineConfigSpeed,
  animationDuration: 200,
  triggerElements: $('.timeline-element-trigger'),
  container: $('.timeline-container-screen-view')
}
let timelineEndPosition = 0

function setupTimeline()
{

  //let customEase = CustomEase.create("custom", "M0,0,C0.318,0.168,0.576,0.374,0.78,0.536,0.82,0.567,0.868,0.68,0.9,0.742,0.947,0.837,0.962,0.894,1,1")
  let customEase = CustomEase.create("custom", "M0,0,C0.168,0.17,0.65,0.654,1,1")

  let timeline = gsap.timeline({
    'smoothChildTiming': true,
    ease: customEase
  })

  //hide scroll animation
  timeline.fromTo('.scroll-animation-container', { opacity: 1, scale: 1 }, {opacity: 0, scale: 0.1, ease: Power4.easeOut, duration: 35}, 100)

  let timeline_elements = timelineConfig.triggerElements
  let containerHalfWidth = timelineConfig.container.width() / 2

  let element_key = 0
  let position = 0
  let element_width = 0
  let element_height = 0
  let previous_year = 0

  let screenWidth = $(window).width()
  let screenHeight = $(window).height()
  let screenHalfHeight = screenHeight / 2

  let startX, startY, endX, endY
  let previous_year_elements = 0

  timeline_elements.each(function(key, v){


      element_width = $(this).width()
      element_height = $(this).height()
      let elementEndScale = 2.5
      let elementStartScale = 0.5

      let element_width_start_scaled = element_width * elementStartScale
      let element_height_start_scaled = element_height * elementStartScale

      let element_width_end_scaled = element_width * elementEndScale
      let element_height_end_scaled = element_height * elementEndScale

      let element_scale_end_width_diff = element_width_end_scaled - element_width
      let element_scale_end_height_diff = element_height_end_scaled - element_height

      let element_scale_start_width_diff = element_width - element_width_start_scaled
      let element_scale_start_height_diff = element_height - element_height_start_scaled

      let xSpacing = screenWidth * 0.07
      let x3Spacing = screenWidth * 0.21

      let centerHeight = $('.centered-content').height()
      let screenLimitHeight = screenHeight * 0.3
      if(breakpoint('screen') < breakpoint('sm')) {
        screenLimitHeight = screenHeight * 0.2
      }
      let centerYearHeight = centerHeight > screenLimitHeight ? screenLimitHeight : centerHeight

      //console.log(centerHeight)
      //console.log(screenLimitHeight)

      element_key += 1


      if(breakpoint('screen') > breakpoint('sm')) {

        position += 12


        if($(this).hasClass('element-bottom-left')) {
          startX = containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = -xSpacing + (element_width_end_scaled / 2) - containerHalfWidth

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2)) * -1
          endY = element_height * 2

          //console.log(containerHalfWidth + ' ' + element_width + ' ' + element_scale_start_width_diff)

        }

        if($(this).hasClass('element-bottom-right')) {
          startX = xSpacing + ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = x3Spacing + containerHalfWidth - (element_width_end_scaled / 2)

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2)) * -1
          endY = element_height * 2
        }

        if($(this).hasClass('element-top-right')) {
          startX = xSpacing + ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = x3Spacing + containerHalfWidth - (element_width_end_scaled / 2)

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2))
          endY = element_height * -2
        }

        if($(this).hasClass('element-top-left')) {
          startX = containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = -xSpacing + ((element_width_end_scaled / 2) - containerHalfWidth)

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2))
          endY = element_height * -2 //scaled height out of screen

        }

        if(key+1 < 5) {
          let nkey = key + 1
              nkey = 5 - nkey
          let keyCoefficient = nkey / 50
          let startedStartX = (endX - startX) * (0.1 + keyCoefficient)
          let startedStartY = (endY - startY) * (0.1 + keyCoefficient)
          startX += startedStartX
          startY += startedStartY

          timeline.fromTo(this, { opacity: 0.5 * nkey}, { opacity: 1, duration: 20 }, position)
          timeline.fromTo(this, { scale: elementStartScale * (1.2 + keyCoefficient) },{ scale: elementEndScale, ease: customEase, duration: 100 }, position)
          timeline.fromTo(this,{ x: startX, y: startY },{ x: endX, y: endY, ease: customEase, duration: 100 }, position)
        } else {
          timeline.fromTo(this, { opacity: 0}, { opacity: 1, duration: 20 }, position)
          timeline.fromTo(this, { scale: elementStartScale },{ scale: elementEndScale, ease: customEase, duration: 100 }, position)
          timeline.fromTo(this,{ x: startX, y: startY },{ x: endX, y: endY, ease: customEase, duration: 100 }, position)
        }



      } else {

        position += 20

        let xPos = element_width_end_scaled - containerHalfWidth - (element_scale_end_width_diff / 2)

        if($(this).hasClass('mobile-top-right')) {
          startX = ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = (screenWidth / 2) + xPos

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * 1.1
          endY = element_height * -2
        }

        if($(this).hasClass('mobile-bottom-right')) {
          startX = -(screenWidth / 8) + ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = xPos

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * -1 * 1.1
          endY = element_height * 2

        }

        if($(this).hasClass('mobile-bottom-left')) {
          startX = -(screenWidth / 8) + containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = 0

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * -1 * 1.1
          endY = element_height * 2
        }

        if($(this).hasClass('mobile-top-left')) {
          startX = containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = (screenWidth / 8)

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * 1.1
          endY = element_height * -2
        }



        if(key+1 < 4) {
          let nkey = key + 1
          nkey = 4 - nkey
          let keyCoefficient = nkey / 50
          let startedStartX = (endX - startX) * (0.1 + keyCoefficient)
          let startedStartY = (endY - startY) * (0.1 + keyCoefficient)
          startX += startedStartX
          startY += startedStartY

          timeline.fromTo(this, { opacity: 0.5 * nkey}, { opacity: 1, duration: 20 }, position)
          timeline.fromTo(this, { scale: elementStartScale * (1.2 + keyCoefficient) },{ scale: elementEndScale, ease: customEase, duration: 100 }, position)
          timeline.fromTo(this,{ x: startX, y: startY },{ x: endX, y: endY, ease: customEase, duration: 100 }, position)
        } else {
          timeline.fromTo(this, { opacity: 0}, { opacity: 1, duration: 20 }, position)
          timeline.fromTo(this, { scale: elementStartScale },{ scale: elementEndScale, ease: customEase, duration: 100 }, position)
          timeline.fromTo(this,{ x: startX, y: startY },{ x: endX, y: endY, ease: customEase, duration: 100 }, position)
        }

      }

      timeline.to(this, {opacity: 0, duration: 0})


  });

  timelineEndPosition = position

  return {
    timeline: timeline,
    timeHeight: timeline_elements.length * timelineConfig.speed
  };

}

function getTimelineTopPosition()
{
  return parseInt(timelineEndPosition + 100);
}


export { setupTimeline, getTimelineTopPosition }